export function accRedircet(url: string) {
  if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
    // If url is absolute

    window.location.href = url;
  }
}

export function fnBrowserDetect() {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }
  return browserName;
}

export function getDevice() {
  let device;
  const updateDevice = () => {
    // let isMobile = document.body.offsetWidth <= 767 ? true : false;
    // let isTablet = document.body.offsetWidth > 767 && document.body.offsetWidth <= 1024 ? true : false;
    // let isDesktop = document.body.offsetWidth > 1024 ? true : false;
    if (document.body.offsetWidth <= 767 ? true : false) {
      device = "Mobile";
    } else if (
      document.body.offsetWidth > 767 && document.body.offsetWidth <= 1024
        ? true
        : false
    ) {
      device = "Tablet";
    } else {
      device = "Desktop";
    }
  };
  updateDevice();

  return device;
}
